export class PastWarrantyActivationSettings {
    maximumDaysForPastActivationDate : number;
    pastActivationAuthorizedRoles : string [];
    enabled : boolean;
}
